import React from 'react'
import AppProvider from './components/Application/AppProvider'

// TODO: (optional) Warning: Not Supported on mobile devices 
// TODO: (UX) How to navigate in 3D
// TODO: (UX) Right click on situation
// TODO: (UX) Light is automatically on 0.5 emission strength
// TODO: (optional) holding mousewheel support
// TODO: (optional) DOCS

function App() {
  return <AppProvider/>
}

export default App
